import { useEffect } from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'
import { has } from 'lodash'

export default function useSetValueAsTZFormat(
  field: ControllerRenderProps<FieldValues, any>
): void {
  const { value: fieldValue } = field

  // This effect need to convert firebase Timestamp into TZ format
  useEffect(() => {
    if (has(fieldValue, 'seconds')) {
      field.onChange(new Date(fieldValue.seconds * 1000).toISOString())
    }
  }, [fieldValue])
}
